
const CustomersList = ({ data, setContactDetails, setContactModal }) => {

    // console.log('first', data)
    return (
        <div className='table-responsive'>
            <table className='jean-table table'>
                <tbody>
                    {
                        data?.map((thera, i) => {
                            return (
                                <tr key={i}>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Student Name</h4>
                                            <p className='mb-0'>{thera?.userInfo?.name || "--"}</p>
                                        </div>
                                    </td>

                                     <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Contact No.</h4>
                                            <p className='mb-0'>{thera?.userInfo?.mobile || "--"}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Email</h4>
                                            <p className='mb-0'>{thera?.userInfo?.email || "--"}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Lessons</h4>
                                            <p className='mb-0 ps-2'>{thera.totalLessons}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Completed</h4>
                                            <p className='mb-0 ps-2'>{thera.completedLessons}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>In Progress</h4>
                                            <p className='mb-0 ps-2'>{thera.inProgressLessons}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Pending</h4>
                                            <p className='mb-0 ps-2'>{thera.pendingLessons}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='action-buttons pe-2'>
                                            <button
                                                onClick={() => {
                                                    if (thera?.userInfo) {
                                                        setContactModal(true)
                                                        setContactDetails(thera?.userInfo || {})
                                                    }
                                                }}
                                                className='bg-black border-0'>
                                                <i className="icon-eye text-white"></i>
                                            </button>
                                        </div>
                                    </td>

                                    {/* <td>
                                            <Dropdown overlay={
                                                <Menu>
                                                    <Menu.Item key={0}>
                                                        <Link className="dropdown-item" to={`${config.appUrl}`}>
                                                            <i className="icon-eye mr-10 text-green"></i>
                                                            View
                                                        </Link>
                                                    </Menu.Item>
                                                    <Menu.Item key={1}>
                                                        <Link className="dropdown-item" to={`${config.appUrl}`}>
                                                            <i className="icon-trash2 mr-10 text-danger"></i>
                                                            Delete
                                                        </Link>
                                                    </Menu.Item>
                                                </Menu>
                                            } className="">
                                                <a
                                                    onClick={(e) => e.preventDefault()}
                                                    className="ps-dropdown__toggle">
                                                    <i className="icon-ellipsis"></i>
                                                </a>
                                            </Dropdown>
                                        </td> */}
                                </tr>
                            )
                        })
                    }

                    {
                        data?.length === 0 &&
                        <div className="alert alert-success ps-4">No Student Found !!</div>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default CustomersList